import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import {GridList, GridTile} from 'material-ui/GridList';

import arrayLoop from '../../utils/loop';

import './index.css';

class Slider extends React.Component {

	render() {
		const styles = {
			paper: {
				backgroundColor: '#F0F0F0',
				width: '100%',
				height: '100%',
				display: 'inline-block',
				padding: 20,
				boxShadow: 0,
			},
			img: {
				width: '100%',
			},
			gridList: {
				display: ((this.props.data || []).img || (this.props.data || []).description) ? 'block' : 'none',
			},
			btnLabel: {
				fontSize: 11,
			},
		};

		const slide = this.props.data;
		const btns = [];

		arrayLoop(slide.buttons, (btn, index) => {
			btns.push(
				<div key={index} className="gohire-thread-card-btn">
					<RaisedButton
						label={btn.label}
						primary={true}
						fullWidth={true}
						labelStyle={styles.btnLabel}
					/>
				</div>
			);
		});

		return (
			<div className="gohire-thread-slider">
				<Paper
					zDepth={2}
					style={styles.paper}
				>
					<div className="gohire-thread-card-img" style={{boxShadow: 'none'}}>
						<GridList
							style={styles.gridList}
						>
							<GridTile
								title={slide.img ? slide.title : ''}
								subtitle={slide.subtitle}
								titlePosition="top"
								titleBackground="linear-gradient(to bottom, rgba(0,0,0,0.7) 0%,rgba(0,0,0,0.3) 70%,rgba(0,0,0,0) 100%)"
								cols={2}
								rows={1}
								style={styles.gridTile}
							>
								<img
									src={slide.img}
									style={{width: '100%', display: slide.img ? 'inline-block' : 'none',}}
								/>
							<div className="gohire-thread-card-desc-wrapper">
								<div className="gohire-thread-card-desc-body">
									<div
										className="gohire-thread-card-desc"
										dangerouslySetInnerHTML={{ __html: slide.description}}
										style={{
											background: 'white',
											padding: 14,
											cursor: 'pointer',
										}}
									></div>
								</div>
							</div>
							</GridTile>
						</GridList>
					</div>
					<div className="gohire-thread-card-title">
						<h4>{slide.img ? '' : slide.title}</h4>
					</div>
					{btns}
				</Paper>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Slider);
